export default "__VITE_ASSET__DxakCRLC__"